import { Pipe, PipeTransform } from '@angular/core'

// For [innerHTML] bindings of announcement-style bodies: HTML values pass through
// untouched, but legacy plain-text values (no markup) are escaped and their
// newlines become <br> so line breaks survive HTML whitespace collapsing.
@Pipe({
  name: 'llaRichText',
  standalone: false
})
export class RichTextPipe implements PipeTransform {
  transform(value?: string): string {
    const v = value ?? ''
    if (/<[a-z][^>]*>/i.test(v)) {
      return v
    }
    return v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>')
  }
}
